
export const ADDRESS_SUFIX: string[] = [
  "Carrera",
  "Calle",
  "Avenida",
  "Ruta",
  "Carretera"
]

export const ADDRESS_COMPLETION: string[] = [
  ...ADDRESS_SUFIX,
  "#",
]
